import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyCheckboxModule as MatCheckboxModule } from "@angular/material/legacy-checkbox";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyChipsModule as MatChipsModule } from "@angular/material/legacy-chips";
import { MatLegacyTabsModule as MatTabsModule } from "@angular/material/legacy-tabs";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from "@angular/material/legacy-autocomplete";

import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatLegacySnackBarModule as MatSnackBarModule } from "@angular/material/legacy-snack-bar";

import { MatLegacySlideToggleModule as MatSlideToggleModule } from "@angular/material/legacy-slide-toggle";

import { MatStepperModule } from "@angular/material/stepper";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { MatLegacyListModule as MatListModule } from "@angular/material/legacy-list";

import { AppComponent } from "./app.component";

import { HomeModule } from "./modules/home/home.module";
import { AppRoutingModule } from "./app-routing.module";
import { CoreModule } from "./core/core.module";
import { CalculateModule } from "./calculator/calc.module";
import { GeneralModule } from "./modules/general/general.module";
import { InvalidBrowserComponent } from "./common/component/invalid-browser/invalid-browser.component";
import { BrowserGuard } from "./common/guard/browser.guard";
import { ExcelService } from "./common/services/excel-export.service";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent, InvalidBrowserComponent],
  imports: [
    BrowserModule,
    CommonModule,
    ToastrModule.forRoot(),
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    BrowserAnimationsModule,
    MatStepperModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatTooltipModule,
    MatTabsModule,

    MatIconModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    FormsModule,
    HttpClientModule,
    MatCheckboxModule,
    MatListModule,

    MatCardModule,
    MatChipsModule,

    HomeModule,
    GeneralModule,
    // HomeRoutingModule,
    AppRoutingModule,
    CoreModule,
    CalculateModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [BrowserGuard],
  bootstrap: [AppComponent],
})
export class AppModule {}
